import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { venomHistory } from 'client/utils/history/venom-history';
import { Link } from 'site-modules/shared/components/link/link';

import './year-link.scss';

const LINK_CLASS_NAME = 'year-btn px-1 py-0_5 bg-white fw-normal';

export function YearLink({ year, url, currentYear, skipCurrentYear, className, trackingId, isButton }) {
  const onClick = useCallback(() => {
    venomHistory.push(url);
  }, [url]);

  const ButtonTag = isButton ? 'button' : Link;
  const buttonProps = isButton ? { onClick, color: 'link' } : { to: url };

  return (
    <li className={classnames('year-link', className)}>
      {skipCurrentYear && year === currentYear ? (
        <div className={classnames(LINK_CLASS_NAME, 'year-current fw-medium text-primary-darker')}>{year}</div>
      ) : (
        <ButtonTag {...buttonProps} className={LINK_CLASS_NAME} data-tracking-id={trackingId}>
          {year}
        </ButtonTag>
      )}
    </li>
  );
}

YearLink.propTypes = {
  year: PropTypes.string,
  url: PropTypes.string,
  currentYear: PropTypes.string,
  trackingId: PropTypes.string,
  className: PropTypes.string,
  skipCurrentYear: PropTypes.bool,
};

YearLink.defaultProps = {
  year: null,
  url: null,
  currentYear: null,
  trackingId: null,
  className: null,
  skipCurrentYear: true,
};
